/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "ii_YbZqHmkU",
    title: "The 3 Most Haunted Places in Asia",
    creator: "Travel + Leisure",
    thumbnail: "https://i3.ytimg.com/vi/ii_YbZqHmkU/maxresdefault.jpg",
    views: "100,454 views",
    date: "Oct 25, 2019",
    category: "Haunted",
    url: "https://www.youtube.com/watch?v=ii_YbZqHmkU",
  },
  {
    _id: "eL85jA5HwJ8",
    title: "7 Mysterious Places in Africa",
    creator: "ohAFRO",
    thumbnail: "https://i3.ytimg.com/vi/eL85jA5HwJ8/maxresdefault.jpg",
    views: "10,219 views",
    date: "Oct 6, 2020",
    category: "Mysterious",
    url: "https://www.youtube.com/watch?v=eL85jA5HwJ8",
  },
  {
    _id: "DUythHvSfJE",
    title: "Abandoned Places in Europe",
    creator: "Secret Truths",
    thumbnail: "https://i3.ytimg.com/vi/DUythHvSfJE/maxresdefault.jpg",
    views: "10,670 views",
    date: "Jan 23, 2020",
    category: "Abandoned",
    url: "https://www.youtube.com/watch?v=DUythHvSfJE"
  },
  {
    _id: "afTaB3qkyNc",
    title: "Haunted Places in the American South",
    creator: "Destination Tips",
    thumbnail: "https://i3.ytimg.com/vi/afTaB3qkyNc/maxresdefault.jpg",
    views: "7,032 views",
    date: "Apr 29, 2019",
    category: "Abandoned",
    url: "https://www.youtube.com/watch?v=afTaB3qkyNc"
  },
  {
    _id: "K3D0ZKsEWY4",
    title: "Mysterious Places in The United States",
    creator: "World According To Briggs",
    thumbnail: "https://i3.ytimg.com/vi/K3D0ZKsEWY4/maxresdefault.jpg",
    views: "1,177,446 views",
    date: "Apr 3, 2020",
    category: "Mysterious",
    url: "https://www.youtube.com/watch?v=K3D0ZKsEWY4",
  },
];
